import ContactCategories from './ContactCategories';

export default ContactCategories;
